import { ESTACIO_INICIALITZAR, ESTACIO_INTRODUCCIO_MOSTRAR_ERRORS } from '../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const mostrarErrors = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_MOSTRAR_ERRORS:
            return true;

        default:
            return state;
    }
};

export default mostrarErrors;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/mostrarErrors.js